(function () {
    'use strict';

    angular.module('app')
        .factory('config', ['$window', '$timeout', '$log', configFactory])
        .config(['$httpProvider', '$compileProvider', function ($httpProvider, $compileProvider) {
            if (!$httpProvider.defaults.headers.get) {
                $httpProvider.defaults.headers.get = {};
            }

            //disable IE ajax request caching
            $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
            $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
        }]);

    function configFactory() {
        var current = config;
        config.environment = environment;
        return current;
    }
})();
